import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import api from "../utils/api";
import { Context } from '../context/UserContext'

const ProtectedRoute = ({ children, setLoggedIn }) => {

  const { authenticated } = useContext(Context)
  const navigate = useNavigate();

  useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        // Redireciona para login se não houver token
        localStorage.removeItem("token");
        navigate("/login");
        return;
      }

      try {
        // Verifica o token no backend
        await api.get("/users/checkuser", {
          headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        });
      } catch (error) {
        // Se o token for inválido, remove-o e redireciona
        localStorage.removeItem("token");
        navigate("/login");
      }
    };

    if (!authenticated) {
      // Redireciona para login se não estiver logado
      localStorage.removeItem("token");
      navigate("/login");
    } else {
      // Verifica o token no backend
      verifyToken();
      setLoggedIn(true);
    }
  }, [authenticated, navigate, setLoggedIn]);

  return children;
};

export default ProtectedRoute;
